// extracted by mini-css-extract-plugin
module.exports = {"input_discount":"InputDiscount_input_discount__vNAzR"};